// University logos for destination slider
import cambridge from '../assets/cambridge.png';
import oxford from '../assets/oxperd.png';
import wharton from '../assets/Wharton.png';
import ethz from '../assets/ETH-z.png';
import columbia from '../assets/Columbia.png';
import caltech from '../assets/caltech.png';
import princeton from '../assets/Princeton.png';
import harvard from '../assets/Harvard_1Resize.png';
import lse from '../assets/LSE.png';
import yale from '../assets/Yale.png';
import mit from '../assets/MIT.png';
import cornell from '../assets/Cornell University.png';

export const UNI_SLIDES = [
  [cambridge, oxford, wharton, ethz],
  [columbia, caltech, princeton, harvard],
  [lse, yale, mit, cornell],
];